import { forwardRef } from 'react';

import { TProps } from '../types/TProps';
import { NeutralButtonChrome } from './NeutralButtonChrome';

export const ToolbarActionButton = forwardRef<HTMLButtonElement, TProps>(({ className, ...props }, ref) => (
  <NeutralButtonChrome ref={ref} className={['btn--toolbar', className].filter(Boolean).join(' ')} {...props} />
));

ToolbarActionButton.displayName = 'ToolbarActionButton';
